export default __webpack_public_path__ + "static/media/file.bdb3e255.svg";